import React from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { lireDate, niveauUrgence, useAttente } from "../../navigation/attente";
import { estMissionClient } from "../../utilities/publicationQuete";
import EnTetePage from "../../components/charte/EnTetePage";
import { Indicateur3 } from "../../components/charte/TroisBarres";
import { BoutonSecondaire } from "../../components/charte/Boutons";
import { COULEUR_DOMAINE } from "../../theme/tribeTheme";
import { AIDE_QUETES } from "../../aide/textesAide";

/* À traiter › Quêtes à valider : les quêtes au statut « À valider »
   (en_attente_validation), demandes clients comprises, la plus ancienne
   d'abord. Lues par l'appel existant GET /quest/all ; la relecture et la
   publication se font dans le détail de la quête (mêmes contrôles). */

const jours = (d: Date) => Math.max(0, Math.floor((Date.now() - d.getTime()) / 86400000));

export default function QuetesAValider() {
  const attente = useAttente(true);
  const quetes = attente.quetes
    .filter(q => (q.statut ?? "").toLowerCase() === "en_attente_validation")
    .sort((a, b) => (lireDate(a.createdAt)?.getTime() ?? 0) - (lireDate(b.createdAt)?.getTime() ?? 0));

  return (
    <Box sx={{ p: { xs: 2, md: 3.5 }, maxWidth: 1180 }}>
      <EnTetePage
        domaine="traiter"
        titre="Quêtes à valider"
        phrase="Quêtes et demandes clients à relire. Ouvrez une quête pour vérifier son prix, puis la valider et la publier."
        aide={AIDE_QUETES.aValider}
      />
      {quetes.length === 0 ? (
        <Typography sx={{ color: "var(--c-text-secondary)", fontSize: 14 }}>
          {attente.charge ? "Aucune quête n'attend de validation." : "Lecture des quêtes…"}
        </Typography>
      ) : (
        <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0, border: "1.5px solid var(--c-text-primary)", borderRadius: "8px", background: "var(--c-surface)", overflow: "hidden" }}>
          {quetes.map((q, i) => {
            const cree = lireDate(q.createdAt);
            const client = estMissionClient(q);
            return (
              <Box component="li" key={q.id} sx={{
                display: "grid", gridTemplateColumns: { xs: "1fr", md: "minmax(0,1fr) auto auto" }, gap: 2, alignItems: "center",
                px: 2.25, py: 1.5, borderTop: i ? "1px solid var(--c-border)" : "none",
                borderLeft: `6px solid ${COULEUR_DOMAINE.quetes}`,
              }}>
                <Box sx={{ minWidth: 0 }}>
                  <Typography sx={{ fontWeight: 700, fontSize: 15 }}>{q.titre || "Quête sans titre"}</Typography>
                  <Typography sx={{ fontSize: 12.5, color: "var(--c-text-secondary)" }}>
                    {client ? `Demande client${q.commanditaire ? ` · ${q.commanditaire}` : ""}` : "Quête Tribe"}
                    {q.parentQuestId ? " · cycle d'une quête récurrente" : ""}
                    {cree ? ` · créée le ${cree.toLocaleDateString("fr-FR")}` : ""}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Indicateur3 niveau={niveauUrgence(cree)} libelle="Urgence" detail={cree ? `en attente depuis ${jours(cree)} j` : "ancienneté inconnue"} />
                  <Typography sx={{ fontSize: 12, color: "var(--c-text-secondary)", whiteSpace: "nowrap" }}>
                    {cree ? (jours(cree) === 0 ? "aujourd'hui" : `depuis ${jours(cree)} j`) : "ancienneté inconnue"}
                  </Typography>
                </Box>
                <BoutonSecondaire component={RouterLink as any} to={`/quetes/${q.id}`}>Relire la quête</BoutonSecondaire>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
}
